export default function ProfileDropDown({ children, onClick }) {
  return (
    <li
      className={
        "flex justify-between items-center p-default rounded-default text-lg font-regular cursor-pointer transition-all hover:bg-theme-primary-hover select-none"
      }
      onClick={async () => onClick && (await onClick())}
      onMouseDown={(event) => {
        event.stopPropagation();
        event.preventDefault();
      }}
    >
      {children}
    </li>
  );
}
